// extracted by mini-css-extract-plugin
module.exports = {"imageList":"List-module__imageList___i5_zM","image":"List-module__image___1mJeJ","pcContainer":"List-module__pcContainer___3ZdJD"};